import { graphql, Link, navigate } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import React, { useEffect, useRef } from 'react'
import Layout from '../../components/Layout/Layout'
import profileApi from '../../services/ProfileAPI'
import { getStoredUser, setStoredUser } from '../../services/auth'
import * as styles from './index.module.css'
import { Helmet } from 'react-helmet'

function Login(props) {

  const { contentfulAsset } = props.data

  // states
  const [loading, setLoading] = React.useState(false)
  const [loginError, setLoginError] = React.useState('')

  //  refs
  const userNameValue = useRef(null)
  const passValue = useRef(null);

  useEffect(() => {
    if (getStoredUser()?.accessToken) navigate('/');
  }, [])

  const onLoginSubmit = () => {
    setLoginError('')

    const loginDetails = {
      username: userNameValue.current?.value.toString(),
      password: passValue.current?.value.toString(),
    };
    setLoading(true)
    profileApi.getLogin(loginDetails)
      .then(res => {
        setLoading(false)
        setStoredUser(res.data)
        navigate('/')
      })
      .catch(err => {
        setLoading(false)
        setLoginError(err.response?.data?.message || 'Incorrect username or password.')
      })
  }

  return (
    <Layout>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Login - Loack&Load</title>
      </Helmet>
      <div className={styles.login}>
        <div className={styles.image}>
          <GatsbyImage image={contentfulAsset.gatsbyImageData} alt={contentfulAsset.title} />
        </div>
        <h1>Load and Lock</h1>
        <div className={styles.inputField}>
          <input placeholder='Username' type='text' ref={userNameValue} />
          <input placeholder='Password' type='password' ref={passValue} />
          <Link className={styles.forgotPassword} to='/forgot-password'>Forgot password?</Link>
        </div>
        {loading ?
          <p className={styles.singInBtn}>Loading...</p>
          :
          <p className={styles.singInBtn} onClick={onLoginSubmit}>Sign In</p>
        }
        <p className={styles.newAccount}><Link to='/signup'>Create a new Account</Link></p>
      </div>
      {loginError && (
        <div className={styles.modalOverlay} onClick={() => setLoginError('')}>
          <div
            className={styles.modal}
            onClick={(event) => event.stopPropagation()}
            role='dialog'
            aria-modal='true'
            aria-labelledby='login-error-title'
          >
            <h2 id='login-error-title'>Sign In Failed</h2>
            <p>{loginError}</p>
            <button
              type='button'
              className={styles.modalButton}
              onClick={() => setLoginError('')}
            >
              Try Again
            </button>
          </div>
        </div>
      )}
    </Layout>
  )
}

export default Login

export const pageQuery = graphql`
query LoginPageQuery {
  contentfulAsset(title: {eq: "Logo"}) {
    gatsbyImageData(placeholder: TRACED_SVG)
    title
  }
}
`
